import get from 'lodash/get';

export const getLeadChannelFromSearchParams = () => {
  return new URL(get(window, 'location.href')).searchParams.get('leadChannel');
};
